module.exports = __webpack_public_path__ + "static/media/c4bannerModul2_small.72919e18.jpg";